import React, { useState, useCallback } from 'react';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW150HQuery } from './hooks/usePW150HQuery';
import QueryParamsPanel from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryParams, ApproveItem } from '../../services/pw150hApi';
import './PW150HForm.css';

const PW150HForm: React.FC = () => {
  const { loading, approving, data, queried, noData, runQuery, approve, reset } = usePW150HQuery();
  const [vendorFrom, setVendorFrom] = useState('');
  const [vendorTo, setVendorTo] = useState('');
  const [localData, setLocalData] = useState<typeof data>([]);

  const handleQuery = useCallback(() => {
    const params: QueryParams = {
      vendorFrom: vendorFrom.trim() || undefined,
      vendorTo: vendorTo.trim() || undefined,
    };
    runQuery(params).then(() => {});
  }, [vendorFrom, vendorTo, runQuery]);

  // Sync data from hook to local state for editing
  React.useEffect(() => {
    setLocalData(data.map(d => ({ ...d })));
  }, [data]);

  const handleToggleApproved = (index: number, checked: boolean) => {
    setLocalData(prev => prev.map((d, i) => i === index ? { ...d, approved: checked } : d));
  };

  const handleNoteChange = (index: number, note: string) => {
    setLocalData(prev => prev.map((d, i) => i === index ? { ...d, dept_note: note } : d));
  };

  const handleSave = () => {
    const items: ApproveItem[] = localData
      .filter(d => d.approved)
      .map(d => ({ doc_no: d.doc_no, dept_note: d.dept_note }));
    approve(items);
  };

  const handleReset = () => {
    setVendorFrom('');
    setVendorTo('');
    setLocalData([]);
    reset();
  };

  return (
    <PermissionGuard module={Modules.PW150H} action="query">
      <div className="pw150h-container">
        <div className="pw150h-header">
          <h2>廠商資格核准-部門</h2>
        </div>
        <QueryParamsPanel
          vendorFrom={vendorFrom} vendorTo={vendorTo} loading={loading}
          onVendorFromChange={setVendorFrom} onVendorToChange={setVendorTo}
          onQuery={handleQuery} onReset={handleReset}
        />
        <ResultTable
          data={localData} loading={loading} queried={queried} noData={noData}
          approving={approving}
          onToggleApproved={handleToggleApproved} onNoteChange={handleNoteChange}
          onSave={handleSave}
        />
      </div>
    </PermissionGuard>
  );
};

export default PW150HForm;
